import { Box, SvgIcon, Typography } from '@mui/material';
import ArrowForwardIcon from 'assets/icons/arrow-foward.svg';
import MessageIcon from 'components/common/MessageIcon';
import { bool } from 'prop-types';
import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import ProgressiveImage from 'react-progressive-image';
import attachmentShape from 'shapes/attachment';
import documentModal from 'store/app/ui/modals/document/action';
import filesize from 'utils/filesize';
import connector from './connector';

const FileThumbnail = ({ data }) => {
  const dispatch = useDispatch();
  const openDocument = useCallback(() => {
    if (data.httpLink) {
      dispatch(documentModal.open(data.httpLink, null, data.name, false, data.mimeType));
    }
  }, [data.httpLink, data.mimeType, data.name, dispatch]);

  return (
    <Box
      sx={theme => ({
        borderRadius: 0,
        minWidth: 250,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        p: 1.25,
        color: theme.palette.primary.main,
      })}
    >
      <Box
        onClick={openDocument}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 80,
          height: 80,
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        {data.meta?.thumb ? (
          <ProgressiveImage src={data.meta.thumb} placeholder={data.meta.placeholder}>
            {(src, loading) => (
              <Box
                component="img"
                src={src}
                alt={data.name}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  ...(loading && {
                    filter: 'blur(4px)',
                    transform: 'scale(1.05)',
                  }),
                }}
              />
            )}
          </ProgressiveImage>
        ) : (
          <SvgIcon
            onClick={openDocument}
            sx={theme => ({
              fontSize: 36,
              cursor: 'pointer',
              color: theme.palette.primary.main,
            })}
          >
            <MessageIcon message={{ attachments: [data] }} />
          </SvgIcon>
        )}
      </Box>
      <Box
        onClick={openDocument}
        sx={{
          flexGrow: 1,
          pl: 1.25,
          pr: 2.5,
          color: 'inherit',
          cursor: 'pointer',
        }}
      >
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '1.38',
            letterSpacing: '-0.4px',
            color: 'inherit',
          }}
        >
          {data.name}
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            color: 'inherit',
          }}
        >
          {filesize(data.size || 0)}
        </Typography>
      </Box>
      {data.httpLink && (
        <SvgIcon
          onClick={openDocument}
          sx={{
            cursor: 'pointer',
            fontSize: 12,
          }}
        >
          <ArrowForwardIcon />
        </SvgIcon>
      )}
    </Box>
  );
};

FileThumbnail.propTypes = {
  right: bool.isRequired,
  data: attachmentShape.isRequired,
};

export default connector(memo(FileThumbnail));
